import styled, { css } from 'styled-components'

import { styleForMobile, styleForTablet } from '@utils'

import { CTASecondary, RightMenuContent } from '../components'

// Correspond to the button on main bar for desktop and tablet, and the language button on mobile
export const RightPart = styled.div`
  ${({ theme }) => css`
    display: flex;

    ${styleForTablet} {
      margin-right: ${theme.sizes.s6};

      .login,
      ${CTASecondary} {
        display: none;
      }
    }

    ${styleForMobile} {
      border-bottom: solid ${theme.colors.neutral20} ${theme.sizes.s0};
      border-left: solid ${theme.colors.neutral20} ${theme.sizes.s0};

      ${RightMenuContent} {
        display: none;
      }
    }

    li {
      list-style: none;
    }
  `}
`
